import { autoinject } from "aurelia-framework";
import { pluck } from "rxjs/operators";
import { connectTo, Store } from "aurelia-store";
import { applicationLogger } from "../../logging/logger";
import { IState } from "../../store/state";

@autoinject
export class Warnings {

	constructor(private readonly store: Store<IState>) {
		// no-op
	}
}
